import * as React from 'react';
import './BedtimeForm.css';

const BedtimeForm = (props) => {

    const setTime = (e) => {
        e.preventDefault();
        props.setWakeUpTime(e.target.children[0].value);
        props.navigate(3);
    }

    return (
        <div>
            <div id={'banner'}>
                <div id={'arrow'} onClick={() => props.navigate(0)}>
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M16.2426 6.34317L14.8284 4.92896L7.75739 12L14.8285 19.0711L16.2427 17.6569L10.5858 12L16.2426 6.34317Z"
                            fill="#EDA1AB"
                        />
                    </svg>
                </div>
                <span>Heure de réveil</span>
            </div>
            <form onSubmit={(e) => setTime(e)} id={'menuContainer'}>
                <input type="time" id={"time"} required/>
                <input id={'submitBtn'} type="submit" value="Résultat" />
            </form>

        </div>

    );
};

export default BedtimeForm;